module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-down-e3ac5e00.svg";